import styled from 'styled-components';
import FlexContainer from 'common/FlexContainer';

const Column = styled(FlexContainer)`
    flex-direction: column;
`;

export default Column;
